import { twMerge } from 'tailwind-merge';

import { useNftCardSize } from '../hooks';
import { useNftCardContext } from '../nftCardContext/NftCardContext';

type NftCategoryIdBadgeProps = {
  className?: string;
  /** Show the small category marker icon inline (used when the big centred marker is hidden). */
  showMarker?: boolean;
};

const NftCategoryIdBadge = ({ className, showMarker = false }: NftCategoryIdBadgeProps) => {
  const { asset } = useNftCardContext();
  const { isCardLarge, isCardMedium, isCardSmall } = useNftCardSize();
  const isNotSmallCard = isCardLarge || isCardMedium;

  return (
    <div
      className={twMerge(
        'tw-absolute tw-z-10 tw-flex tw-w-max tw-items-center tw-gap-1.5 tw-rounded-2xl tw-bg-backgroundColorMedium tw-py-1 tw-capitalize tw-text-white tw-opacity-80',
        isNotSmallCard && 'tw-left-3 tw-top-3.5 tw-px-3 tw-text-base/[20px]',
        isCardSmall && 'tw-left-2 tw-top-2.5 tw-px-2.5 tw-text-sm/[16px]',
        showMarker && 'tw-pl-1.5',
        className
      )}
    >
      {showMarker && asset?.markerUrl && (
        <img src={asset.markerUrl} alt="" className="tw-h-[18px] tw-w-[18px] tw-shrink-0" />
      )}
      <span>
        {asset?.category} #{asset?.id}
      </span>
    </div>
  );
};

export default NftCategoryIdBadge;
